"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyOnlineStatus = void 0;
// Будет использоваться как в отправке лида в лидхаб,
// так и в парсере доступности онлайн-оплаты (SLT-1190)
var BuyOnlineStatus;
(function (BuyOnlineStatus) {
    /**
     * пока детальная актуализация не завершится (удачно или нет)
     *
     * кнопка покупки будет не доступна
     * НУЖНА ТОЛЬКО ДЛЯ UI (блокирует отправку онлайн-формы), в лидхаб этот статус не отправляется!
     */
    BuyOnlineStatus[BuyOnlineStatus["detailActualizationNotCompleted"] = 7] = "detailActualizationNotCompleted";
    /**
     * данный ТО не поддерживает онлайн оплату (возможно отключено в CRM)
     *
     * кнопка покупки будет не доступна
     */
    BuyOnlineStatus[BuyOnlineStatus["operatorDoesntSupportOnlinePayment"] = 6] = "operatorDoesntSupportOnlinePayment";
    /**
     * тур продан
     *
     * кнопка покупки будет не доступна
     */
    BuyOnlineStatus[BuyOnlineStatus["tourSold"] = 5] = "tourSold";
    /**
     * запрошенная валюта не соответствует рублям
     *
     * кнопка покупки будет не доступна
     */
    BuyOnlineStatus[BuyOnlineStatus["incorrectCurrency"] = 4] = "incorrectCurrency";
    /**
     * дата вылета тура меньше 24 часов от текущей даты
     * отдел онлайн оплат и ЦБ не успеют отправить туриста
     *
     * кнопка покупки будет не доступна
     */
    BuyOnlineStatus[BuyOnlineStatus["lessThanOneDayBeforeDeparture"] = 3] = "lessThanOneDayBeforeDeparture";
    /**
     * детальная актуализация завершилась, но с ошибкой
     */
    BuyOnlineStatus[BuyOnlineStatus["detailActualizationError"] = 2] = "detailActualizationError";
    /**
     * все прочие кейсы, когда оплата доступна
     *
     * кнопка покупки будет доступна
     */
    BuyOnlineStatus[BuyOnlineStatus["available"] = 0] = "available";
})(BuyOnlineStatus = exports.BuyOnlineStatus || (exports.BuyOnlineStatus = {}));
